<template>
  <div class="bg-white p-4 my-3 rounded">
    <validation-observer ref="submissionDateForm">
      <validation-provider v-slot="{ errors }" rules="required">
        <custom-date-picker
          v-model="submissionDate"
          class="cdp-submission"
          label="Fecha de sometido:"
          placeholder="DD/MM/YYYY"
          :error="errors[0]"
          custom-error-msg="La fecha de sometido es requerida"
          :max-date="new Date()"
        />
      </validation-provider>
    </validation-observer>

    <div class="d-flex justify-content-end">
      <action-button
        id="btn-cancelar"
        variant="outline-danger mr-2"
        type="button"
        i="fas fa-times-circle"
        @click="cancel"
      >
        Cancelar
      </action-button>
      <action-button
        id="btn-edit"
        variant="success"
        type="button"
        i="fas fa-save"
        @click="save"
      >
        Guardar
      </action-button>
    </div>
  </div>
</template>
  
  <script>
import ActionButton from 'ActionButton';
import CustomDatePicker from 'custom-date-picker';
import { ValidationProvider, ValidationObserver } from 'vee-validate';

export default {
  name: 'EdenMasterSubmission',
  components: {
    ActionButton,
    CustomDatePicker,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      submissionDate: null,
    };
  },
  methods: {
    async save() {
      const isValid = await this.$refs.submissionDateForm.validate();
      if (!isValid) return;
      this.$emit('save', { ...this.data, date: this.submissionDate });
    },
    cancel() {
      this.data.enableSubmission = false;
    },
  },
};
</script>
  <style scoped>
::v-deep .width-container {
  width: 300px !important;
}
</style>
  